import React from "react";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import reCompact from "../../images/bajaj3.jpg";
import "../../../src/product.css";

const RECompact = () => {
  return (
    <>
      <Header />

      <main className="product-page container text-center">
        {/* Product Hero */}

        <h2 id="title">RE-COMPACT</h2>

        <section className="product-hero">

          <div className="product-image-wrapper">
            <img
              src={reCompact}
              alt="Bajaj RE Compact"
              className="product-image"
            />
          </div>

          <div className="product-info">

            <p>
              Bajaj RE 4S is the leading model for the RE portfolio. It’s an
              ideal mix of practicality coupled with load ability. Its highly
              compact and easy to park, maneuver on the roads yet can carry
              three passengers and extra load without breaking a sweat.
            </p>

          </div>
        </section>

        {/* Specifications */}
        <section className="product-specifications">

          <div className="section-heading">
            <span>TECHNICAL DETAILS</span>
            <h2>Specifications</h2>
          </div>

          <div className="spec-grid">

            <div className="spec-card">
              <span>Engine Type</span>
              <strong>4 Stroke Engine</strong>
            </div>

            <div className="spec-card">
              <span>Cubic Capacity</span>
              <strong>198.88 cc</strong>
            </div>

            <div className="spec-card">
              <span>Transmission</span>
              <strong>4 Forward + 1 Reverse Gear</strong>
            </div>

            <div className="spec-card">
              <span>Fuel Type</span>
              <strong>Diesel</strong>
            </div>

            <div className="spec-card">
              <span>Battery</span>
              <strong>12V</strong>
            </div>

            <div className="spec-card">
              <span>Weight</span>
              <strong>348 kg</strong>
            </div>

            <div className="spec-card">
              <span>Clutch</span>
              <strong>Wet Multidisc Type</strong>
            </div>

            <div className="spec-card">
              <span>Passenger Capacity</span>
              <strong>1D + 3</strong>
            </div>

          </div>
        </section>

      </main>

      <Footer />
    </>
  );
};

export default RECompact;